import { makeStyles } from '@material-ui/styles';
import { getProductPrices } from '@functions/productOps';
import useSessionStore from '@services/stores/SessionStore';

const useStyles = makeStyles(() => ({
    wrapper: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'flex-end'
    },
    oldPrice: {
        textDecorationLine: 'line-through',
        opacity: '0.5',
        //fontSize: '0.7em',
        fontWeight: 400,
    },
    specialPrice: {
        color: '#e65f5f',
        fontWeight: 500,
    },
    regularPrice: {
        fontWeight: 400,
    },
    container: {
        display: 'flex',
        gap: '8px',
        margin: 'auto 0 0 auto'
    },
}), { name: 'ItemPrice' });

export default function ItemPrice({product, className = ''}) {
    const formatPrice = useSessionStore((state) => state.methods.formatPrice);
    const classes = useStyles();
    const prices = getProductPrices(product);

    function renderPrice(prices) {
        return <>
            <div className={classes.regularPrice}>{formatPrice(prices.price)}</div>
        </>
    }

    function renderSpecialPrice(prices) {
        return <div className={classes.wrapper}>
            <div className={classes.oldPrice}>
                {formatPrice(prices.listPrice)}
            </div>
            <div className={classes.specialPrice}>
                {formatPrice(prices.price)}
            </div>
        </div>
    }

    return <>
        <section className={`${classes.container} ${className}`}>
            {prices.isOnSale ? renderSpecialPrice(prices) : renderPrice(prices) }
        </section>
    </>;
}
